// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"154":"css/campaign-create","300":"css/tw","594":"css/campaign-edit"}[chunkId] + ".css";
};